const convertDateToUnixTimestamp = (dateIn) => {
  return dateIn.getTime()/1000|0;
}

module.exports.convertDateToUnixTimestamp = convertDateToUnixTimestamp;